/**
 * Transforms a Supabase storage URL to use the Cloudflare-cached image CDN.
 *
 * The CDN domain (image-proxy.gosellgardens.workers.dev) is a Cloudflare Worker that proxies
 * requests to Supabase storage and adds long-lived Cache-Control headers, reducing
 * egress from Supabase and speeding up repeat image loads.
 *
 * @param {string|null|undefined} url - Original image URL (may be a Supabase storage URL)
 * @returns {string|null|undefined} - URL pointing at the Cloudflare CDN when applicable
 */
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const IMAGE_CDN_BASE = "https://image-proxy.gosellgardens.workers.dev";

export function getImageUrl(url) {
	if (!url) return url;
	if (!SUPABASE_URL) return url;
	const supabaseBase = SUPABASE_URL.replace(/\/$/, "");
	if (url.startsWith(supabaseBase)) {
		return url.replace(supabaseBase, IMAGE_CDN_BASE);
	}
	return url;
}
